import { useNavigate } from "react-router-dom";

export default function Card({ item }) {
  const navigate = useNavigate();

  const handleClick = () => {
    localStorage.setItem("selectedItem", JSON.stringify(item)); // เก็บข้อมูลใน localStorage
    navigate(`/pages/detail/${item.id}`); // ไปยังหน้า Detail
  };

  return (
    <div className="flex flex-col gap-y-2 p-2 rounded-lg justify-between shadow-sm border border-amber-50 hover:shadow-lg transition-shadow">
      {/* รูปภาพ */}
      <div className="w-full h-72 overflow-hidden rounded-t-md">
        <img
          src={item.img ? item.img : "/images/info/notImg.png"}
          alt=""
          className="object-cover w-full h-full"
        />
      </div>

      {/* วันที่ */}
      <div className="flex justify-between items-center text-[#0F4D81] border-b px-1 py-1">
        <i className="fa fa-calendar-minus"></i>
        <span className="text-sm">{item.date}</span>
      </div>

      {/* รายละเอียดแบบ HTML */}
      <div
        className="text-gray-700 text-sm leading-relaxed"
        dangerouslySetInnerHTML={{
          __html:
            item.detail.length > 150
              ? `${item.detail.slice(0, 150)}...`
              : item.detail,
        }}
      ></div>

      {/* ปุ่ม Read More */}
      <div className="flex justify-end">
        <button
          onClick={handleClick}
          className="bg-[#9E76B3] px-3 py-1 rounded-md text-white text-sm hover:bg-[#7c5a91] transition"
        >
          Read more
        </button>
      </div>
    </div>
  );
}
